import React from "react"

export default function GenerationHelpPanel({ onToggle }) {

  return (
    <div className="mt-10 p-10 border border-gray-200 rounded-6 bg-gray-50">
      <h3 className="text-sm text-blue-600 strong">How report generation works</h3>
      <ol className="m-0 pl-20 text-sm text-gray-700 space-y-2">
        <li><strong>Preview</strong> (PDF only): generates the file and opens it immediately in the viewer.
        It does not save the file automatically to your computer.</li>
        <li><strong>Generate</strong>: creates the report in the background and stores it in a temporary area for 24 hours. You can download it several times from the download badge in the top navbar.</li>
        <li>Generated reports are usually faster to download and reopen later.</li>
      </ol>
      <div className="mt-10 text-right">
        <button type="button" onClick={ onToggle } 
          className="border rounded-6 bg-white text-xs p-5 px-10">
          Hide Notes
        </button>
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Reports/GenerationHelpPanel.js